import { render, staticRenderFns } from "./IconFilters.vue?vue&type=template&id=010d0352"
import script from "./IconFilters.vue?vue&type=script&lang=js"
export * from "./IconFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports